import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../../lib/database.types';
import { getTodayDateStringInBusinessTZ } from '../../utils/date';

/**
 * Soft-unenroll: deactivate an enrollment without deleting it.
 *
 * NEVER hard-delete an enrollment row. A DELETE cascades (ON DELETE CASCADE) through
 * invoices → invoicing_line_items → payments → refunds → stripe_transactions, permanently
 * destroying paid financial history (this caused a real data-loss incident). This mirrors the
 * CLI/MCP unenroll path (cli-api handleUnenroll): set is_active=false and close the
 * enrollment_end_date to today, which also stops future invoice generation for recurring programs.
 * The enrollment stays recoverable (reactivate via is_active toggle).
 */
export async function softUnenrollEnrollment(
  client: SupabaseClient<Database>,
  enrollmentId: string,
): Promise<void> {
  const { error } = await client
    .from('enrollments')
    .update({ is_active: false, enrollment_end_date: getTodayDateStringInBusinessTZ() })
    .eq('id', enrollmentId);

  if (error) {
    throw new Error(error.message);
  }
}
